export default from './StudentPanelList';


// WEBPACK FOOTER //
// ./js/components/StudentPanelList/index.js